const defaultSelectedStyle = { name: "No style", image_url: "/remove_back/magic_bg/no_style.png", isNoStyle: true, id: 0, strength: 0 }
const defaultQueueInfo = { users: 1, time: 15 }

export { defaultSelectedStyle, defaultQueueInfo }